<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           query-api="getTpmData"
                           @emFilterQueried="handleQueried"
                           @doClear="initFilter()"
                           $_em-custom-vuex-mixin_filter="spindleDataImageFilter"
                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesTpmSpindleDataTsdResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <mini-table ref="miniTable"
                          read-only
                          needModelFields
                          :items="tpmSpindleData"
                          style="min-height: 350px;"
                          entity-name="sithMesTpmSpindleDataTsd">
                <template #rightHeader>
                  <b-button variant="outline-primary"
                            :disabled="!tpmSpindleData.length>0 || exportLoading"
                            @click="downloadExcel()">
                    <b-spinner small v-if="exportLoading" type="grow"></b-spinner>
                    导出
                  </b-button>
                </template>
              </mini-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
  </div>
</template>
<script>
// Author Liu Cui Cui
// Date 2022-07-19 18:33:15

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
  name: "sithMesTpmSpindleDataTsdListView",
  components: {MiniTable},
  mixins: [emCommonListMixin, emCustomVuexMixin],
  data() {
    return {
      tpmSpindleData: [],
      exportLoading: false
    }
  },
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    }
  },
  computed: {
    modelName() {
      return 'sithMesTpmSpindleDataTsd'
    }
  },
  mounted() {
    this.initFilter();
  },
  methods: {
    initFilter() {
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('tsdCollectTimeRteFilter', currentDate.getTime());
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('tsdCollectTimeLteFilter', new Date());
    },
    handleQueried(response) {
      const opcRecords = response.data.opcRecords
      this.tpmSpindleData = opcRecords || []
    },
    downloadExcel() {
      this.exportLoading = true;
      const queryForm = this.$store.state[this.modelName]["spindleDataImageFilter"]
      let exportUrl = this.$store.state.sithMesTpmSpindleDataTsd.baseModuleUrl + "/sithMesTpmSpindleDataTsd/export";
      this.$store.dispatch("api/postReportDownload", {
        url: exportUrl,
        data: queryForm,
      }, {root: true})
          .then(res => {
            let blob = new Blob([res], {
              type: `application/zip;charset-UTF-8`
            });
            let objectURL = URL.createObjectURL(blob);
            let downEle = document.createElement('a');
            downEle.href = objectURL;
            downEle.setAttribute('download', '主轴数据.xls');
            downEle.click();
            this.exportLoading = false;
          })
    },
  }
};
</script>
